<template>
  <div class="mb-3">
    <text-input v-model="form.name" :error="form.errors.name" label="Name" />
    <text-input v-model="form.email" :error="form.errors.email" label="Email" />
    <text-input v-model="form.phone" :error="form.errors.phone" label="Phone" />
    <text-input v-model="form.address_1" :error="form.errors.address_1" label="Address line 1" />
    <text-input v-model="form.address_2" :error="form.errors.address_2" label="Address line 2" />
    <text-input v-model="form.postal_code" :error="form.errors.postal_code" label="Postal code" />
    <text-input v-model="form.city" :error="form.errors.city" label="City" />
    <SelectCountry v-model="form.country" :error="form.errors.country" label="Country" />
  </div>
</template>

<script>
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import SelectCountry from '@/Shared/SelectCountry'

export default {
  components: {
    SelectInput,
    SelectCountry,
    TextInput,
  },
  name: 'AgencyForm',
  props: {
    form: Object
  }
}
</script>

<style>

</style>
